import type { PropsWithChildren } from 'react';
import { cn } from '#pie/utils/TailwindUtils';

export interface DescriptionListProps extends PropsWithChildren {
  className?: string;
  variant?: 'horizontal' | 'grid';
}

export function DescriptionList({
  className,
  children,
  variant = 'horizontal',
}: DescriptionListProps) {
  return (
    <dl
      className={cn(
        'text-content-heading',
        variant === 'horizontal'
          ? 'grid grid-cols-1 gap-x-4 gap-y-4 xl:grid-cols-[min-content,_minmax(9rem,_1fr)]'
          : 'grid grid-cols-1 gap-4 lg:grid-cols-2',
        className,
      )}
    >
      {children}
    </dl>
  );
}

export { DescriptionListItem } from './description-list-item/DescriptionListItem';
